'use strict';

import { matchesBreakpoint, queryFirst, queryAll } from './domUtil';
import { stickyScrollPosition } from './util';
import { sauce } from 'fitpredictor/product/secretsauce';
import detail from './product/detail';
import pdpQuickView from './product/pdpQuickView';
import notifyMe from './components/notifyMe';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/shippingPreference'));
    processInclude(detail);
    processInclude(notifyMe);
    processInclude(require('./components/imageSlider'));
    processInclude(require('./components/modal'));
    processInclude(require('./components/pickUpInStore'));
    processInclude(require('instore/product/pdpInstoreInventory'));
    if (!!queryFirst('#fitPredictorEnabled')) {
        sauce($('.product-detail.product-wrapper'));
    }
    processInclude(require('./product/monogram'));
    const pdpContainer = queryFirst('.pdp-container');
    if (pdpContainer) {
        const selectedSize = queryFirst('.size-btn.selected');
        if (selectedSize) {
            selectedSize.click();
        }
    }
    processInclude(pdpQuickView);
    processInclude(require('./product/stickyCTA'));

    // Afterpay
    require('./afterpay')({
        anchors: '.product-price-row',
        renderMode: 'adjacent',
        observerTargets: '.prices',
        priceTargets: ['.sales .price-value', '.list .price-value', '.sales .value'],
        showExcluded: false
    });

    if (matchesBreakpoint('md')) {
        stickyScrollPosition(queryAll('.pdp-details'));
    }
});
